export const GET_TODAY_TIMELINE_SUCCEED = 'TodayTimeline/GET_SUCCEEDED';
export const GET_TODAY_TIMELINE_ERROR = 'TodayTimeline/GET_ERROR';

export const GET_CLIENT_TIMELINE_SUCCEED = 'ClientTimeline/GET_SUCCEEDED';
export const GET_CLIENT_TIMELINE_ERROR = 'ClientTimeline/GET_ERROR';

export const CLEAR_CLIENT_TIMELINE_STATE = 'ClientTimeline/CLEAR_STATE';
export const LOADING_STATE = 'Timeline/LOADING_STATE';